module.exports = __webpack_public_path__ + "img/pr-1.5e381562.png";